export const triggerDownloadFromBlob = (blob: Blob, fileName: string): void => {
  const newUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = newUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a); // Clean up the DOM
  window.URL.revokeObjectURL(newUrl); // Clean up the object URL
};

export const audioStringToMp3Blob = (audioString: string): Blob => {
  const decodedAudioData = atob(audioString);
  const len = decodedAudioData.length;
  const byteArray = new Uint8Array(len);
  for (let i = 0; i < len; i++) byteArray[i] = decodedAudioData.charCodeAt(i);
  return new Blob([byteArray], { type: 'audio/mpeg' });
};

export const downloadAndRenameFile = async (url: string, fileName: string): Promise<void> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Network response was not ok - ${url}`);
  }

  const blob = await response.blob();
  triggerDownloadFromBlob(blob, fileName);
};
